import React, { useState } from "react"
import { Link, useParams } from "react-router-dom"
import Back from "../common/Back"
import img from "../images/about.jpg"
import { authFetch } from "../../lib/api"
import "./auth.css"

const ResetPassword = () => {
  const { token } = useParams()
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (password !== confirmPassword) {
      setError("Passwords do not match")
      return
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters")
      return
    }
    if (!token) {
      setError("Invalid reset link")
      return
    }
    setError("")
    setLoading(true)
    try {
      const res = await authFetch("/api/auth/reset-password", {
        method: "POST",
        body: JSON.stringify({ token, newPassword: password }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || "Reset failed")
        return
      }
      setSubmitted(true)
    } catch (err) {
      setError("Something went wrong. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className='auth-section'>
      <Back name='Reset password' title='Choose a new password' cover={img} />
      <div className='auth-page'>
        <div className='container'>
          <div className='auth-card'>
            <h1 className='auth-card__title'>Set new password</h1>
            <p className='auth-card__subtitle'>
              {submitted
                ? "Your password has been reset. You can sign in now."
                : "Enter your new password below."}
            </p>

            {error && <p className='auth-error'>{error}</p>}

            {!submitted ? (
              <>
                <form onSubmit={handleSubmit} className='auth-form'>
                  <label htmlFor='reset-password'>New password</label>
                  <input
                    id='reset-password'
                    type='password'
                    placeholder='••••••••'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <label htmlFor='reset-confirm'>Confirm new password</label>
                  <input
                    id='reset-confirm'
                    type='password'
                    placeholder='••••••••'
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
<button type='submit' className='auth-form__submit' disabled={loading}>
                  {loading ? "Resetting…" : "Reset password"}
                </button>
                </form>
                <div className='auth-footer'>
                  <Link to='/signin'>Back to sign in</Link>
                </div>
              </>
            ) : (
              <div className='auth-footer' style={{ borderTop: "none", paddingTop: 0 }}>
                <Link to='/signin' className='auth-form__submit' style={{ display: "block", textAlign: "center", textDecoration: "none", color: "#ffffff" }}>
                  Sign in
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ResetPassword
